export { OnlyChild as ElOnlyChild, OnlyChild } from './src/only-child.mjs';
//# sourceMappingURL=index.mjs.map
